module.exports = __webpack_public_path__ + "img/animal-quiz.2bb3d1b0.jpg";